import React, { useState } from 'react'
import { Button, Card, Drawer, notification, Select } from 'antd'
import { useDispatch } from 'react-redux'
import { InputBox } from '../../../components/_utils/appUtils'
import { updateAbstractStatusFxn } from './actions'

const { Option } = Select;

const UpdateStatusDrawer = (props) => {
  let { visible, onClose, abstract, onSubmit } = props
  let dispatch = useDispatch()
  let statusList = ['Submitted Abstract','Abstract Under Process', 'Under Review', 'Approved', 'Processed']

  let [status, setStatus] = useState(abstract.status || '')

  const updateStatus = async () => {
    if (!status) {
      notification.warning({ message: 'Please choose a status.' })
      return
    }

    let obj = {
      status,
      abstractId: abstract._id
    }

    let { success, data } = await dispatch(updateAbstractStatusFxn(obj))
    if (success) {
      notification.success({ message: 'Status updated successfully' })
      onSubmit(data) // Refreshes the parent view with new data
    }
  }

  return (
    <Drawer
      title={`Update Status | ID: ${abstract.onlineAbstractId}`}
      visible={visible}
      width={'35%'}
      onClose={onClose}>
      <Card>
        <InputBox title={'Status'} bordered={false}>
          <Select
            style={{ width: '100%' }}
            onChange={(val) => setStatus(val)}
            value={status}>
            {statusList.map((s, key) => (
              <Option value={s} key={key}>
                {s}
              </Option>
            ))}
          </Select>
        </InputBox>
        <Button
          type='primary'
          onClick={updateStatus}
          style={{ marginTop: 20 }}>
          Submit
        </Button>
      </Card>
    </Drawer>
  )
}

export default UpdateStatusDrawer
